import { NextArrow, PrevArrow } from "@components/CustomerReviewCardSlider/CustomerReviewCardSlider";
import FeaturedListingItemCard, { FeaturedListingItemDesktopCard, FeaturedListingItemType } from "@components/ListingItemCard/FeaturedListingItemCard";
import { ListingDetailsType } from "@utils/ListingTypes";
import React from "react";
import Slider from "react-slick";
import { Container } from "semantic-ui-react";
import { FeaturedListingsContainer } from "./Listings.styles";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
type FeaturedListingsProps ={
    listings: ListingDetailsType[]
}


//TODO: the breakpoint for the responsive slider need to match the page breakpoint
const FeaturedListingSliderContainer = (props: FeaturedListingsProps) =>{
    const desktopSliderSettings = {
        dots: true,
        autoplay: true,
        autoPlaySpeed: 3000,
        slidesToShow: 2,
        slidesToScroll: 2,
        draggable: false,
        arrows: true,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        responsive:[
            {
                breakpoint: 1024,
                settings:{
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 768,
                settings:{
                    slidesToShow: 1,                    
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 480,
                settings:{
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            }
        ]
    }
    console.log("number list featured listings: ", props.listings.length)
    return (
        <FeaturedListingsContainer>
            <Slider {...desktopSliderSettings}>
                    {
                        props.listings.map(item=>{
                            return <FeaturedListingItemDesktopCard {...item} />
                        })
                    }
                </Slider>
            {/* <div className="hidden md:block lg:hidden">
            <Slider {...tabletSliderSettings}>
                    {
                        props.listings.map(item=>{
                            return <FeaturedListingItemCard {...item} />
                        })
                    }
                </Slider>
            </div>

            <div className="block md:hidden">
            <Slider {...mobileSliderSettings}>
                    {
                        props.listings.map(item=>{
                            return <FeaturedListingItemCard {...item} />
                        })
                    }
                </Slider>
            </div> */}
        </FeaturedListingsContainer>
    )
}
export default FeaturedListingSliderContainer;